
define('ldsh!modules/contact/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Contact</h1>\n<dl>\n  \n\t <dd>\n   <span name="first_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="last_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="email"></span>\n  </dd>\n  \n\t <dd>\n   <span name="phone1"></span>\n  </dd>\n  \n\t <dd>\n   <span name="phone2"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

